import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import css from 'react-css-modules';
import classnames from 'classnames';

const SetsResultsIcon = createReactClass({
  propTypes: {
    onClicked: PropTypes.func.isRequired,
    name: PropTypes.string,
    unicodeChar: PropTypes.string,
    iconSet: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
  },

  render() {
    const iconClassName = classnames(
      `icon-set-preview-112-${this.props.iconSet.slug}`,
      `icon-set-preview-112-${this.props.iconSet.slug}-${this.props.name}`
    );
    const onClicked = (event) => {
      event.preventDefault();

      this.props.onClicked(this.props.name, this.props.iconSet.slug);
    };

    return (
      <li className="asset asset-icon">
        <a href="#" className="block asset-link link-dashed-none" onClick={onClicked}>
          <div className="icon-preview m-xs-b-xs">
            <i className={iconClassName}></i>
          </div>
          <div className="icon-label">
            <span className="block m-xs-b-xs">{this.props.name}</span>
            <span className="block font-weight-semibold">{this.props.iconSet.name}</span>
          </div>
        </a>
      </li>
    );
  },
});

export default SetsResultsIcon;



// WEBPACK FOOTER //
// ./app/javascript/views/Sets/components/SetsResultsIcon.js